<template>
  <div>
    <v-select
      label="Átjáró"
      :error-messages="errors.gateway_id"
      v-model="connection.gateway_id"
      :items="gateways"
      item-text="name"
      item-value="element_id"
      filled
      :value-comparator="$config.comparators.isEqual" />

    <!-- <v-text-field v-model="connection.name" label="Név" :error-messages="errors.name" filled
      v-mask="$config.inputMasks.name" /> -->

    <v-text-field
      v-model="connection.ip"
      label="IP cím"
      :error-messages="errors.ip"
      filled />

    <v-text-field
      v-model="connection.port"
      label="Port"
      :error-messages="errors.port"
      filled />

    <v-text-field
      v-model="connection.rs232_port_dev_name"
      label="RS232 Port"
      :error-messages="errors.rs232_port_dev_name"
      filled
      v-mask="$config.inputMasks.name" />

    <v-text-field
      v-model="connection.rs232_baud_rate"
      label="RS232 Baud rate"
      :error-messages="errors.rs232_baud_rate"
      filled
      v-mask="$config.inputMasks.createNumberMask({ min: 9600, max: 921600 })" />

    <v-textarea
      v-model="connection.comment"
      label="Megjegyzés"
      filled
      rows="3"
      auto-grow />
  </div>
</template>

<script>
export default {
  props: {
    value: Object,
    id: Number,
    errors: {
      type: Object,
      default: () => ({}),
    },
  },

  data: () => ({
    loading: false,
    connection: {
      element_id: null,
      name: null,
      ip: null,
      port: null,
      gateway_id: null,
      rs232_port_dev_name: null,
      rs232_baud_rate: null,
      comment: null,
    },
    gateways: [],
  }),

  watch: {
    connection: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        this.$emit('input', newValue);
      },
    },

    value: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue) {
          this.connection = newValue;
        }
      }
    }
  },

  mounted() {
    this.fetchGateways();
  },

  methods: {

    async fetchGateways() {
      const response = await this.$http.get(`gateways/list`);
      this.gateways = response.gateways;
    },
  },
};
</script>